var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.storeIsLoading)?_c('b-loading',{attrs:{"active":"","is-full-page":false}}):(_vm.store)?_c('tabs-page',{attrs:{"tabs":_vm.tabs,"title":_vm.store.description,"keep-alive":false}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }